import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import * as r from 'constants/routes';

const setHeaders = (headers) => {
    headers.set('Content-Type', 'application/json');
    headers.set('x-applicat-apikey', process.env.REACT_APP_API_KEY);
    return headers;
};

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
        return setHeaders(headers);
    }
});

export const loginApi = createApi({
    reducerPath: 'loginApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        loginWithCredentials: builder.mutation({
            query: ({ user, password }) => ({ url: r.LOG_IN, method: 'POST', body: { user, password } }),
            transformResponse: (apiResponse, meta) => {
                return { body: apiResponse, headers: meta.response.headers };
            }
        }),
        loginWithToken: builder.query({
            query: (token) => (`${r.LOG_IN}/${token}`),
            transformResponse: (apiResponse, meta) => {
                return { body: apiResponse, headers: meta.response.headers };
            }
        }),
    })
});

export const { useLoginWithCredentialsMutation, useLazyLoginWithTokenQuery } = loginApi;